import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CustomerProvider } from "@/context/CustomerContext";
import SmoothScroll from "@/components/SmoothScroll";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Ledger from "@/pages/Ledger";
import Story from "@/pages/Story";
import Testimonials from "@/pages/Testimonials";
import Club from "@/pages/Club";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Account from "@/pages/Account";
import CustomerLogin from "@/pages/CustomerLogin";

// Capture an ambassador referral (?ref=CODE) so it auto-applies at checkout
function RefCapture() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) {
      localStorage.setItem("drift_ref", ref.trim().toUpperCase());
      const url = new URL(window.location.href);
      url.searchParams.delete("ref");
      window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    }
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <AuthProvider>
        <CartProvider>
          <CustomerProvider>
          <BrowserRouter>
            <SmoothScroll>
              <RefCapture />
              <CartDrawer />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/story" element={<Story />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/club" element={<Club />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/login" element={<CustomerLogin />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/ledger" element={<Ledger />} />
              </Routes>
            </SmoothScroll>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
          </CustomerProvider>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
